















import Vue from "vue";
import DiamondSupportList from "@/components/dashboards/DiamondSupportList.vue";
import ReminderList from "@/components/dashboards/ReminderList.vue";
import { Component } from "vue-property-decorator";

@Component({
  components: {
    DiamondSupportList,
    ReminderList,
  },
})
export default class UserDashboard extends Vue {

}
